__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "veComponents";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@enterprise-ui/canvas-ui-css-autocomplete", "7.21.1", () => (__webpack_require__.e(398).then(() => (() => (__webpack_require__(60398))))));
			register("@enterprise-ui/canvas-ui-css-datepicker", "7.21.1", () => (__webpack_require__.e(292).then(() => (() => (__webpack_require__(47292))))));
			register("@enterprise-ui/canvas-ui-css-gallery", "7.21.1", () => (__webpack_require__.e(390).then(() => (() => (__webpack_require__(59390))))));
			register("@enterprise-ui/canvas-ui-css", "7.21.1", () => (Promise.all([__webpack_require__.e(116), __webpack_require__.e(817)]).then(() => (() => (__webpack_require__(24817))))));
			register("@enterprise-ui/canvas-ui-react", "7.21.1", () => (Promise.all([__webpack_require__.e(101), __webpack_require__.e(283), __webpack_require__.e(342), __webpack_require__.e(205), __webpack_require__.e(236)]).then(() => (() => (__webpack_require__(81101))))));
			register("@enterprise-ui/icons", "1.17.5", () => (Promise.all([__webpack_require__.e(177), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(16177))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(108), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(28108))))));
			register("react-router", "7.9.6", () => (Promise.all([__webpack_require__.e(745), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(16745))))));
			register("react", "18.3.1", () => (__webpack_require__.e(685).then(() => (() => (__webpack_require__(66685))))));
			initExternal(39794);
			initExternal(64718);
			initExternal(15918);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};